import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { authClient } from '~/shared/lib/auth';

export const useSignOutMutation = (href: string) => {
    return useMutation({
        mutationKey: ['signOut'],
        mutationFn: async () => {
            const { error } = await authClient.signOut();
            if (error) {
                throw new Error('Не удалось выйти из аккаунта');
            }
        },
        retry: false,
        onSuccess: () => {
            const url = href || '/';
            setTimeout(() => {
                window.location.replace(url);
            }, 0);
        },
        onError: error => {
            toast.error(error.message);
        },
    });
};
